var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"width":350,"closable":false,"visible":_vm.visible,"close-after-confirm":false,"append-to-body":true},on:{"close":function($event){return _vm.$emit('close')},"confirm":_vm.logout}},[_c('div',{staticClass:"logout-text"},[_vm._v("\n    "+_vm._s(_vm.$t('logout.confirm-with-mark'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }